import axios from "axios";
import { API_BASE_URL } from "./constants/app-constants";
import { getAuthToken } from "../helper/local-storage/local-storage-helper";
import { logoutUser } from "../context/auth-context";
import { jwtDecode } from "jwt-decode";

const AXIOS_INSTANCE = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
AXIOS_INSTANCE.interceptors.request.use(
  (config) => {
    const token = getAuthToken(); // Replace with your actual token
     if (token) {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now()) {
        logoutUser();
        return Promise.reject("Token expired");
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

AXIOS_INSTANCE.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      logoutUser();
    }
    return Promise.reject(error);
  }
);

export default AXIOS_INSTANCE;
